module.exports = __webpack_public_path__ + "media/images/emblems/Soral-coat_of_arms-c6eb00e8deab8d98ef2a2ecb16d22a0b.svg";